// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import MenuDefaultProps from "@insite/mobius/Menu/presentationProps";
import { xBaseTheme } from "@keller/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...MenuDefaultProps,
        moreIconProps: {
            size: 24,
            css: css`
                padding-right: 5px;
                position: absolute;
                top: 5px;
                right: 0;
            `,
            src: "ChevronRight",
        },
    },
} as xBaseTheme["menu"];
